import { MutableRefObject, useRef } from 'react';

export function useLatest<T>(current: T): MutableRefObject<T> {
    const storedValue = useRef(current);

    storedValue.current = current;

    return storedValue;
}
